export { default } from './EmptySyncStock';
